var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartLeftImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 600,
    viewBox: "0 0 597 1094",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "start-left-image_svg__mask0_1214_31835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 597,
    height: 1094
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1 0 0 1 597 0)",
    fill: "#C4C4C4",
    d: "M0 0h597v1093.01H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#start-left-image_svg__mask0_1214_31835)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-589.33 2.557c0 278.88 225.511 504.957 503.683 504.957 278.171 0 503.674-226.045 503.674-504.957H-589.33zM-589.33 508.792c0 278.881 225.511 504.958 503.683 504.958 278.171 0 503.674-226.045 503.674-504.958H-589.33z"
  }))));
}
export default SvgStartLeftImage;